import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import homeVideo from '../assets/videos/home.mp4';

export const HomeSection = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
        videoRef.current.playbackRate = 0.5;
        }
    }, []);

    return (
        <div className="relative min-h-screen flex items-center justify-start overflow-hidden w-full bg-[#e8e8e8]">
            <div className="absolute top-0 left-0 w-full h-full z-0 opacity-30">
                <video
                    ref={videoRef}
                    autoPlay
                    loop
                    muted
                    className="object-fill sm:object-cover w-full h-full opacity-30 backdrop-blur-sm"
                >
                <source src={homeVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

            <div className="mx-auto px-4 sm:px-8 md:px-12 relative z-10 w-full">
                <div className="grid grid-cols-1 lg:grid-cols-1 gap-8 md:gap-12 items-center w-full">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-center lg:text-left space-y-6 w-full"
                    >
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.2 }}
                            className="inline-flex flex-row items-center gap-2 bg-gradient-to-r from-gray-300 to-gray-500/20 backdrop-blur-sm border border-gray-400 rounded-full px-4 py-2"
                        >
                            {/* <div className="absolute inset-1 rounded-full bg-gradient-to-r from-gray-300 to-gray-400 -z-20 animate-ping [animation-duration:2s]"></div> */}
                            <div className="absolute inset-1 scale-75 rounded-full bg-gradient-to-r from-gray-300 to-gray-400 -z-20 animate-ping [animation-duration:2s]"></div>
                            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent to-gray-100 -z-10"></div>
                            <a href="#contact" className="bg-gradient-to-r from-gray-700 to-gray-600 text-white text-xs sm:text-sm px-3 py-1 rounded-full font-medium">
                                New
                            </a>
                            <a href="#contact" className="text-gray-900 text-xs sm:text-sm font-medium">
                                You may contact us for more information.
                            </a>
                        </motion.div>

                        <motion.h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold tracking-tight font-display space-y-0 sm:space-y-3 text-gray-600">
                            {[
                                "Smart Solutions, Real Impact",
                                "High Technologies for a Smarter Future",
                                "Efficiency Meets Sustainability",
                            ].map((word, i) => (
                            <motion.span
                                key={word}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3 + i * 0.1 }}
                                className="block bg-gradient-to-r from-gray-800 via-gray-500 to-gray-400 bg-clip-text"
                            >
                                {word}
                            </motion.span>
                            ))}
                        </motion.h1>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};
